import axios from "axios";
import store from "../store";

class Airtable {

    async get_records(credential, base_id, table_name) {
      let jwt = store.state.jwt;

      return new Promise(function (resolve, reject) {
        axios
          .post(
            process.env.VUE_APP_SAAS_BACK + "/airtable/records",
            {
              credential_name: credential,
              base: base_id,
              table: table_name,
            },
            {
              headers: { Authorization: "Bearer " + jwt },
            }
          )
          .then(function (response) {
            var data = response.data;
            resolve(data);
          })
          .catch(function (error) {
            reject({ name: error.response.status, message: error.response.data.msg });
          });
      })
    }

    async get_credentials() {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/airtable/credentials",
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });

    }

    async get_bases(credential) {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/airtable/bases",
					{
						credential_name: credential,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					resolve(data);
				})
				.catch(function (error) {
					reject({ name: error.response.status, message: error.response.data.msg });
				});
		});
    }

    async get_tables(credential, base_id) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/airtable/tables/" + base_id,
                    {
                        credential_name: credential
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					resolve(data);
				})
				.catch(function (error) {
					reject({ name: error.response.status, message: error.response.data.msg });
				});
		});
    }

    async get_fields(credential, base_id, table_name) {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/airtable/fields",
					{
						credential_name: credential,
						base: base_id,
						table: table_name,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					resolve(data);
				})
				.catch(function (error) {
					reject({ name: error.response.status, message: error.response.data.msg });
				});
		});
    };

    async get_mapping(smd_table_name) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/airtable/mapping",
					{
                        "smd_table": smd_table_name
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					resolve(data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
    };

    async export_airtable(credential, base_id, airtable_id, smd_table, column_mappings) {
        let jwt = store.state.jwt;

        let payload = {
            credential_name: credential,
            base: base_id,
            smd_table: smd_table,
            target_airtable: airtable_id,
            column_mappings: column_mappings
        }

        return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/airtable/export",
					{
						credential_name: credential,
						base: base_id,
						smd_table: smd_table,
						target_airtable: airtable_id,
                        column_mappings: column_mappings
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					// if (!data.add_file)
					// 	data.add_file = [];
					// data.add_file.forEach((element) => {
					// 	element.checkbox = false;
					// });
					resolve(data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
    };

    async import_airtable(credential, base_id, table_id, smd_table, column_mappings, ged_mappings) {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					process.env.VUE_APP_SAAS_BACK + "/airtable/import",
					{
						credential_name: credential,
						base: base_id,
						table_id: table_id,
                        smd_table: smd_table,
                        column_mappings: column_mappings,
                        ged_mappings: ged_mappings
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					resolve(data);
				})
				.catch(function (error) {
					reject(error);
				});
		}); 
    }
}

export default new Airtable();